import { chakra } from '@chakra-ui/react';
import React from 'react';

import type { NavItem, NavGroupItem } from 'types/client/navigation';

import IconSvg from 'ui/shared/IconSvg';

const DEFAULT_ICON_SIZE = 30;

interface Props {
  className?: string;
  item: NavItem | NavGroupItem;
  size?: number;
  color?: string;
}

const NavLinkIcon = ({ item, className, size = DEFAULT_ICON_SIZE, color }: Props) => {
  if ('icon' in item && item.icon) {
    return (
      <IconSvg
        className={ className }
        name={ item.icon }
        boxSize={ `${ size }px` }
        flexShrink={ 0 }
        color={ color || 'currentColor' }
      />
    );
  }
  if ('iconComponent' in item && item.iconComponent) {
    const IconComponent = item.iconComponent;
    return <IconComponent className={ className } size={ size }/>;
  }

  return null;
};

export default chakra(NavLinkIcon);
